module.exports = __webpack_public_path__ + "9506e62f5f07c34d1410a8ef66b60958.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/state_farm_2021_chart.png
// module id = 1727
// module chunks = 0